var map = {
	"./assets/en/scene1_2x.jpeg": 59995,
	"./assets/scene1_2x.jpeg": 39985,
	"pages/home/assets/en/scene1_2x.jpeg": 59995,
	"pages/home/assets/scene1_2x.jpeg": 39985
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92927;